<template>
  <div>
    <div class="text-grey-8 text-caption">
      <slot>
        {{ label || '-' }}
      </slot>
    </div>

    <div>
      <slot name="value">
        {{ value || '-' }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PairValues',
  props: {
    label: [String, Number],
    value: [String, Number],
    horizontal: Boolean,
  },
};
</script>

<style lang="scss" scoped></style>
